/**
 * Converts a hex color code to an RGB object
 */
function hexToRgb(hex: string) {
  const parsedHex = hex.replace(/^#/, '');
  const bigint = parseInt(parsedHex, 16);
  /* eslint-disable no-bitwise */
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
}

/**
 * Interpolates between two colors based on a normalized value (0 to 1)
 */
function interpolateColorThreeStops(
  startHex: string,
  midHex: string,
  endHex: string,
  normalized: number,
): string {
  const start = hexToRgb(startHex);
  const mid = hexToRgb(midHex);
  const end = hexToRgb(endHex);

  let r;
  let g;
  let b;

  if (normalized <= 0.5) {
    // Interpolate between start and mid
    const localNormalized = normalized * 2; // Scale to 0-1 range for this segment
    r = Math.round(start.r + (mid.r - start.r) * localNormalized);
    g = Math.round(start.g + (mid.g - start.g) * localNormalized);
    b = Math.round(start.b + (mid.b - start.b) * localNormalized);
  } else {
    // Interpolate between mid and end
    const localNormalized = (normalized - 0.5) * 2; // Scale to 0-1 range for this segment
    r = Math.round(mid.r + (end.r - mid.r) * localNormalized);
    g = Math.round(mid.g + (end.g - mid.g) * localNormalized);
    b = Math.round(mid.b + (end.b - mid.b) * localNormalized);
  }

  return `rgb(${r}, ${g}, ${b})`;
}

/**
 * Function to reduce color opacity
 * @param rgb
 * @param opacityFactor
 * @returns
 */
const reduceColorOpacity = (rgb: string, opacityFactor = 0.6) => {
  const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (!match) return rgb; // fallback if not valid rgb

  const [, r, g, b] = match;
  return `rgba(${r}, ${g}, ${b}, ${opacityFactor})`;
};

export { hexToRgb, interpolateColorThreeStops, reduceColorOpacity };
